import { Wrench } from "lucide-react";
import { useApp } from "@/context/AppContext";

export default function MaintenancePage() {
  const { settings } = useApp();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-6 grain" data-testid="maintenance-page">
      <div className="accent-glow w-80 h-80 bg-primary/20 top-10" />
      <div className="relative z-10 max-w-md">
        <span className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-primary/15 text-primary mb-6 animate-float">
          <Wrench className="w-8 h-8" />
        </span>
        <h1 className="font-head text-3xl font-extrabold mb-4">
          {settings.site_name || "ARAN TOOLS"}
        </h1>
        <p className="text-muted-foreground leading-relaxed">
          {settings.maintenance_message || "الموقع تحت الصيانة حاليًا. سنعود قريبًا."}
        </p>
      </div>
    </div>
  );
}
